import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1ci0rl0-0"
})(["align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;left:0;position:absolute;right:0;text-align:center;top:0;z-index:1;"]);
export default Container;